module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_right_link-fed7ba2405dadab96cbf301ae639c770.svg";